// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ky","header":"kz","title":"kA","subheader":"kB","formWrapper":"kC"};